import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ManageCategories } from "components/manage-categories/manage-categories.jsx";
import {
  createCategoryAction,
  setAddCategoryVisibilityAction,
  updateNewCategoryNameAction,
  removeIncludeRuleAction,
  selectCategoriesAction,
  deselectCategoriesAction,
  deleteCategoriesAction,
  focusCategoryAction,
  unfocusCategoryAction,
  updateCategoryNameAction,
  removeDropdownRuleAction,
  updateIncludeVendorsAction,
  setDeleteCategoriesVisibilityAction,
  saveCategoryChangesAction,
  orderCategoriesAction
} from "actions/categories-actions";
import { trackPageAction } from "actions/shared/tracking-actions";

const ManageCategoriesPage = (props) => {
  props.trackPage();
  return <ManageCategories { ...props } />;
};

ManageCategoriesPage.propTypes = {
  trackPage: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  categories: state.categories.categories,
  focusedCategory: state.categories.focusedCategory,
  isAddCategoryVisible: state.categories.isAddCategoryVisible,
  isDeleteCategoriesLoading: state.categories.isDeleteCategoriesLoading,
  isDeleteCategoriesVisible: state.categories.isDeleteCategoriesVisible,
  isSaveCategoryLoading: state.categories.isSaveCategoryLoading,
  newCategory: state.categories.newCategory,
  newIncludeRules: state.categories.newIncludeRules,
  orderBy: state.categories.orderBy,
  orderDirection: state.categories.orderDirection,
  selectedCategoryIds: state.categories.selectedCategoryIds,
  slug: state.app.selectedAccount.slug,
  vendors: state.vendors.vendors
});

const mapDispatchToProps = (dispatch) => ({
  trackPage: () => dispatch(trackPageAction("Manage categories page")),
  onCreateCategory: (accountId, category) => dispatch(createCategoryAction(accountId, category)),
  onDeleteCategories: () => (dispatch(deleteCategoriesAction())),
  onFocusCategory: (category, style) => dispatch(focusCategoryAction(category, style)),
  onHideAddCategory: () => dispatch(setAddCategoryVisibilityAction(false)),
  onHideDeleteCategories: () => dispatch(setDeleteCategoriesVisibilityAction(false)),
  onOrderBy: (column) => dispatch(orderCategoriesAction(column)),
  onSaveCategory: (data) => dispatch(saveCategoryChangesAction(data)),
  onShowAddCategory: () => dispatch(setAddCategoryVisibilityAction(true)),
  onShowDeleteCategories: () => dispatch(setDeleteCategoriesVisibilityAction(true)),
  onUnfocusCategory: () => dispatch(unfocusCategoryAction()),
  onUpdateNewCategoryName: (name) => dispatch(updateNewCategoryNameAction(name)),
  onUpdateCategoryName: (name) => dispatch(updateCategoryNameAction(name)),
  onUpdateIncludeVendors: (vendor) => dispatch(updateIncludeVendorsAction(vendor)),
  onRemoveDropdownRule: (rule, isNew) => dispatch(removeDropdownRuleAction(rule, isNew)),
  onRemoveIncludeRule: (accountId, categoryId, ruleId) => {
    dispatch(removeIncludeRuleAction(accountId, categoryId, ruleId));
  },
  onRowsDeselected: (ids) => dispatch(deselectCategoriesAction(ids)),
  onRowsSelected: (ids) => dispatch(selectCategoriesAction(ids))
});

export const ManageCategoriesContainer = connect(mapStateToProps, mapDispatchToProps)(ManageCategoriesPage);



// WEBPACK FOOTER //
// ./src/js/containers/manage-categories-container.jsx